import React from 'react';
import styled from 'styled-components';
import theme from '../theme';

const EditWrapper = ({ onBack, children }) => {
  return (
    <Wrapper>
      <BackRow>
        <BackBtn onClick={onBack}>
          {'\u2190'} Back to View
        </BackBtn>
      </BackRow>
      <EditArea>
        {children}
      </EditArea>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  font-family: ${theme.typography.fontFamily};
`;

const BackRow = styled.div`
  margin-bottom: ${theme.spacing.md};
`;

const BackBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  background: none;
  border: none;
  color: ${theme.colors.primary};
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.body.size};
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  transition: color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.primaryDark};
  }
`;

const EditArea = styled.div`
  /* Minor overrides to make Semantic UI less jarring in v2 layout */
  .ui.form .field > label {
    font-family: ${theme.typography.fontFamily};
  }
  .ui.segment {
    border-radius: ${theme.radii.sm};
  }
`;

export default EditWrapper;
